export const FAQ = "https://youtu.be/xD5Itu4G42A";
export const S22M = "https://www.savills.com.vn/s22m/index.aspx";
